export default [{
  path: 'examination',
  name: 'examination',
  component: function component() {
    return import('@/views/bidManage/examination/index');
  }
}, {
  path: 'examination/vehicleInfo',
  name: 'examinationVehicleInfo',
  component: function component() {
    return import('@/views/bidManage/components/vehicleInfo');
  }
}, {
  path: 'examination/employeeInfo',
  name: 'examinationEmployeeInfo',
  component: function component() {
    return import('@/views/bidManage/components/employeeInfo');
  }
}, {
  path: 'examinationDetail',
  name: 'examinationDetail',
  component: function component() {
    return import('@/views/bidManage/examination/detail');
  }
}, {
  path: 'supplier',
  name: 'supplier',
  component: function component() {
    return import('@/views/bidManage/supplier/index');
  }
}, {
  path: 'reviewsSuccess',
  name: 'reviewsSuccess',
  component: function component() {
    return import('@/views/bidManageNew/reviewManageNew/success');
  }
}, {
  path: 'reviewFlowDestroy',
  name: 'reviewFlowDestroy',
  component: function component() {
    return import('@/views/bidManageNew/reviewManageNew/flowDestroy');
  }
}, {
  path: 'reviewFlowSuccess',
  name: 'reviewFlowSuccess',
  component: function component() {
    return import('@/views/bidManageNew/reviewManageNew/flowSuccess');
  }
}, {
  path: 'supplierDetail',
  name: 'supplierDetail',
  component: function component() {
    return import('@/views/bidManage/supplier/detail');
  }
}, {
  path: 'buildBiddingSuccess',
  name: 'buildBiddingSuccess',
  component: function component() {
    return import('@/components/bidding/buildBidding/success');
  }
}, {
  path: 'loadometerList',
  name: 'loadometerList',
  component: function component() {
    return import('@/views/bidManage/loadometerList/index');
  }
}, {
  path: 'loadometerListUpdate',
  name: 'loadometerListUpdate',
  component: function component() {
    return import('@/views/bidManage/loadometerList/update');
  }
}, {
  path: 'loadometerManagement',
  name: 'loadometerManagement',
  component: function component() {
    return import('@/views/bidManage/loadometerManagement/index');
  }
}];